import * as React from 'react'
import {type LicenseT} from '@frontrow/console/src/entities/models/license'

import {type MultipleSubjectLicensesT} from '@frontrow/console/src/components/common/school-licenses-list'
import SchoolLicensesList from '@frontrow/console/src/components/common/school-licenses-list/school-licenses-list'

type Props = {
  schoolName: string
  licenses: Array<LicenseT>
  isLoading: boolean
  error: string | undefined | null
  addNewLicenses: (licensesData: MultipleSubjectLicensesT) => void
  removeLicense: (licenseId: number) => void
  courseSubjectsByLicensing: boolean
  setCourseSubjectsByLicensing?: (courseSubjectsByLicensing: boolean) => void
  enableModifications: boolean
}

type State = {
  shouldShowNewLicense: boolean
  showNewLicenseConstraint: boolean
  duplicatedLicense: LicenseT | undefined | null
}

function getDefaultState(): State {
  return {
    shouldShowNewLicense: false,
    showNewLicenseConstraint: false,
    duplicatedLicense: null
  }
}

export default function SchoolLicensesListContainer(props: Props): React.ReactElement {
  const [state, setState] = React.useState<State>(getDefaultState())

  const showNewLicense = (license?: LicenseT | null) => {
    setState((prevState: State) =>
      prevState.shouldShowNewLicense
        ? {
            ...prevState,
            showNewLicenseConstraint: true
          }
        : {
            ...prevState,
            shouldShowNewLicense: true,
            showNewLicenseConstraint: false,
            duplicatedLicense: license
          }
    )
  }

  const hideNewLicense = () => {
    setState(getDefaultState())
  }

  const addNewLicenses = (licenseData: MultipleSubjectLicensesT) => {
    props.addNewLicenses(licenseData)
    setState(getDefaultState())
  }

  const {shouldShowNewLicense, showNewLicenseConstraint, duplicatedLicense} = state
  const {addNewLicenses: _addNewLicenses, ...rowProps} = props

  return (
    <SchoolLicensesList
      showNewLicense={showNewLicense}
      hideNewLicense={hideNewLicense}
      addNewLicenses={addNewLicenses}
      showNewLicenseConstraint={showNewLicenseConstraint}
      shouldShowNewLicense={shouldShowNewLicense}
      duplicatedLicense={duplicatedLicense}
      {...rowProps}
    />
  )
}
